import React from 'react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { IssueStatusEnum } from '@features/IIMReview/types';
/**
 * Component that renders action buttons for issue cards based on the current feedback state
 */
export default function ActionButtons({ status, onSuggestCorrection, onDismissIssue, onUndoAction, readOnly, markedForSuggestion, hideSuggestCorrection = false, onResolveDeficiency, onReopenDeficiency }) {
    // Render different buttons based on the status
    if ([IssueStatusEnum.Resolved, IssueStatusEnum.DismissedByBackOffice, IssueStatusEnum.Suggested].includes(status) ||
        markedForSuggestion) {
        return (React.createElement("div", { className: "issue-card__actions" },
            React.createElement(Button, { onClick: onUndoAction, "aria-label": translate('undo_action', { namespace: 'features.iim_review.issue_card' }), disabled: readOnly },
                React.createElement("i", { className: "fa-light fa-arrows-repeat" }),
                ' ',
                translate('undo', { namespace: 'features.iim_review.issue_card' }))));
    }
    return (React.createElement("div", { className: "issue-card__actions" },
        onReopenDeficiency && (React.createElement(Button, { onClick: onReopenDeficiency, "aria-label": translate('reopen_deficiency', { namespace: 'features.iim_review.issue_card' }), disabled: readOnly },
            React.createElement("i", { className: "fa-light fa-rotate-left" }),
            ' ',
            translate('reopen', { namespace: 'features.iim_review.issue_card' }))),
        onResolveDeficiency && (React.createElement(Button, { onClick: onResolveDeficiency, "aria-label": translate('resolve_deficiency', { namespace: 'features.iim_review.issue_card' }), disabled: readOnly },
            React.createElement("i", { className: "fa-light fa-check-circle" }),
            ' ',
            translate('resolve_deficiency', { namespace: 'features.iim_review.issue_card' }))),
        !hideSuggestCorrection && (React.createElement(Button, { onClick: onSuggestCorrection, "aria-label": translate('suggest_correction', { namespace: 'features.iim_review.issue_card' }), disabled: readOnly },
            React.createElement("i", { className: "fa-light fa-message-lines" }),
            ' ',
            translate('suggest_correction', { namespace: 'features.iim_review.issue_card' }))),
        React.createElement(Button, { onClick: onDismissIssue, "aria-label": translate('dismiss_issue', { namespace: 'features.iim_review.issue_card' }), disabled: readOnly },
            React.createElement("i", { className: "fa-light fa-xmark" }),
            " ",
            translate('dismiss', { namespace: 'features.iim_review.issue_card' }))));
}
